module.exports = __webpack_public_path__ + "img/img3.798035df.jpg";